/**
 * ⭐ **İSTEMCİ İÇİ GEZİNME** — `location.assign()` yerine.
 *
 * ════════════════════════════════════════════════════════════════════════
 * 🚨 ÇÖZDÜĞÜ HATA: KATILIM JETONU ODAYA GİRERKEN KAYBOLUYORDU
 * ════════════════════════════════════════════════════════════════════════
 * Katılım akışı şuydu:
 *
 * ```ts
 * setAccessToken(res.accessToken);      // jeton YALNIZ BELLEKTE (Rapor 03 §3.4)
 * location.assign(`/room/${meetingId}`); // ⛔ TAM SAYFA YÜKLEMESİ
 * ```
 *
 * `location.assign` tüm JavaScript durumunu siler. Oda açıldığında
 * `getAccessToken()` boş dizge döndürüyordu. Tek kurtarma yolu yenileme
 * çereziydi (`centvox_rt`) — o da `SameSite=Strict` olduğu için Pages ile
 * Worker ayrı sitelerdeyken **hiç gönderilmiyor**. Yani katılım akışı
 * uçtan uca tamamlanamıyordu.
 *
 * ### ⚠️ Neden jetonu depolamaya yazmadık?
 * `sessionStorage`'a yazmak en hızlı çözümdü ama Rapor 03 §3.4'ün "erişim
 * jetonu yalnız bellekte" kuralını bozardı ve XSS yüzeyini kalıcı olarak
 * genişletirdi. `history.pushState` ile geçiş yapmak, jetonu bellekte
 * tutarak aynı sonucu verir — kural korunur, hata çözülür.
 *
 * ### ⚠️ Bir router kütüphanesi DEĞİLDİR
 * Tek bir dinleyici tutar ve yalnız uygulama kabuğuna hizmet eder. Rota
 * eşleştirmesi hâlâ `app/route.ts` içindedir (Rapor 14 §3.2: router
 * kütüphanesi kritik yola 8–15 KB ekler ve bu ürüne karşılığı yoktur).
 */

type Listener = (path: string) => void;

/**
 * ⚠️ Tek dinleyici bilinçlidir: kabuk bir tanedir. Dizi tutmak, unutulan bir
 *    aboneliğin sessizce sızmasına ve iki kez render'a yol açardı.
 */
let listener: Listener | null = null;

export function onNavigate(next: Listener): () => void {
  listener = next;
  return () => {
    // ⚠️ Yalnız KENDİ dinleyicimizi kaldırırız: React 18+ StrictMode
    //    effect'leri iki kez çalıştırır ve körlemesine `null` yazmak,
    //    ikinci kaydın hemen ardından onu silerdi.
    if (listener === next) listener = null;
  };
}

/**
 * Yeni bir yola geçer.
 *
 * ⚠️ Yalnız **göreli** yollar kabul edilir. Mutlak bir URL geçirilirse
 *    `pushState` başka bir origin'e yazamaz ve `SecurityError` fırlatır;
 *    daha kötüsü, çağıran taraf bunu bir yönlendirme aracı sanabilirdi.
 */
export function navigate(to: string): void {
  if (!to.startsWith("/")) throw new Error("navigate_requires_absolute_path");
  history.pushState(null, "", to);
  listener?.(location.pathname);
}

/**
 * Tarayıcının geri/ileri düğmelerini kabuğa bağlar.
 *
 * ⚠️ Olmadan: kullanıcı odadan geri gider, adres çubuğu değişir ama ekran
 *    değişmez — sayfa donmuş görünür.
 */
export function watchHistory(next: Listener): () => void {
  const onPop = (): void => next(location.pathname);
  window.addEventListener("popstate", onPop);
  return () => window.removeEventListener("popstate", onPop);
}
